<template>
  <ListeZone />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ListeZone from "@/components/Parametres/ListeZone.vue";

export default defineComponent({
  name: "ListeZonePage",
  components: {
    ListeZone,
  },
});
</script>

